var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93555 6.98157C1.93555 4.46368 3.37809 3.38458 5.5419 3.38458H12.7546C14.9184 3.38458 16.361 4.46368 16.361 6.98157V12.0174C16.361 14.5352 14.9184 15.6143 12.7546 15.6143H5.5419",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7537 7.34128L10.4961 9.13977C9.75323 9.72968 8.53428 9.72968 7.79138 9.13977L5.54102 7.34128",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93555 12.7368H6.26317",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93555 9.85916H4.09936",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnselected);
export default __webpack_public_path__ + "static/media/onselected.51fc230b0776f43f3eb2241e46a9991d.svg";
export { ForwardRef as ReactComponent };